<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="false"
  >
    <template #subHeaderActions>
      <div class="d-flex align-items-center gap-2 gap-lg-3">

      </div>
    </template>
    <template #layoutContent>
      <FileManager v-bind:settings="settings" />
    </template>
  </SubLayout>
</template>
<script setup>
import {computed, ref} from "vue";
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import FileManager from "@/Modules/FileManager/views/FileManager";
import Ls from "@/services/ls";
import {BASE_URL} from "@/services/api";


const title = ref("navigation.documents")
const breadcrumbs = ref([
  {
    name: 'navigation.documents',
    path: '/admin/file-manager/view'
  }
])

const settings = computed(() => {
  const AUTH_TOKEN = Ls.get('auth.token')
  return {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Authorization: `Bearer ${AUTH_TOKEN}`,
    },
    baseUrl: BASE_URL + '/file-manager/',   // overwrite base url Axios
    windowsConfig: 1,                           // overwrite config
    lang: 'fr'
  }
})

</script>
